import { Routes } from '@angular/router';
import { CustomerGuard } from '@next/core-lib/relationships';

import { deviceRedirectGuard } from '../shared/guards/device-redirect.guard';
import { moduleActivationGuard } from '../shared/guards/module-activation.guard';
import { AdviceComponent } from './components/advice/advice.component';

export const blightRoutes: Routes = [
  {
    path: 'blight-redirect',
    redirectTo: 'blightV2',
  },
  {
    path: 'blightV2',
    component: AdviceComponent,
    canActivate: [CustomerGuard, deviceRedirectGuard, moduleActivationGuard('blight')],
  },
];
